// Service Worker registration with update-handling.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (window.location.hostname === "localhost" && !window.location.search.includes("sw=1")) return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("pwa:update-ready"));
          }
        });
      });
    } catch (e) {
      console.warn("[pwa] SW registration failed", e);
    }
  });
}

registerServiceWorker();

export function clearApiCache() {
  if (!("serviceWorker" in navigator)) return Promise.resolve();
  return new Promise((resolve) => {
    const ctrl = navigator.serviceWorker.controller;
    if (!ctrl) return resolve();
    const channel = new MessageChannel();
    channel.port1.onmessage = (e) => { if (e.data?.type === "API_CACHE_CLEARED") resolve(); };
    ctrl.postMessage({ type: "CLEAR_API_CACHE" }, [channel.port2]);
    setTimeout(resolve, 1500);
  });
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}
